export const objectRemove = (canvas, id) => {
  return {
    ...canvas,
    selectedObject: null,
    objects: canvas.objects.filter(object => object.id !== id),
  };
};
